import { getSunrise, getSunset } from "sunrise-sunset-js";
import { useGeoCoordinates } from "./useGeoCoordinates";
import { DateTime } from "luxon";

export function useNightLessonInDaylightWarning(formValues: {
  drivingLessonType: string;
  dateTime?: DateTime;
  durationInMinutes: number;
  startingPointId?: string;
}): string | null {
  const { drivingLessonType, dateTime, durationInMinutes, startingPointId } = formValues;
  const geoCoordinates = useGeoCoordinates(startingPointId);
  if (dateTime && dateTime.isValid && durationInMinutes && drivingLessonType === "nachtfahrt" && geoCoordinates) {
    const hour = dateTime.setZone("Europe/Berlin").hour;
    if (hour <= 12) {
      const sunrise = DateTime.fromJSDate(getSunrise(geoCoordinates.lat, geoCoordinates.lng, dateTime.toJSDate()), {
        zone: "Europe/Berlin",
      });
      if (sunrise < dateTime.plus({ minutes: durationInMinutes - 13 })) {
        return `Nachtfahrt bei Tageslicht (Sonnenaufgang: ${sunrise.toFormat("HH:mm")} Uhr)`;
      }
    } else {
      const sunset = DateTime.fromJSDate(getSunset(geoCoordinates.lat, geoCoordinates.lng, dateTime.toJSDate()), {
        zone: "Europe/Berlin",
      });
      if (dateTime < sunset.minus({ minutes: 13 })) {
        return `Nachtfahrt bei Tageslicht (Sonnenuntergang: ${sunset.toFormat("HH:mm")} Uhr)`;
      }
    }
  }
  return null;
}
